<template>
  <div class="team-review p-0"
       :data-submission="submission.id"
       :data-user="user.id"
  >
    <div class="text-right pb-0 pt-0">
      <button @click.prevent="activeChart = 'current'" :class="activeChart === 'current' ? 'active' : ''"
              class="btn mr-1 btn-primary"><i class="fal fa-chart-pie"></i></button>
      <button @click.prevent="activeChart = 'evolution'" :class="activeChart === 'evolution' ? 'active' : ''"
              class="btn btn-primary"><i class="fal fa-chart-line"></i>
      </button>
    </div>
    <div class="current-team-scores row" v-show="activeChart === 'current'">
      <div class="col-md-8  mb-5">
        <generic-chart class="col-md-12"
                       @clickData="vitaminChartClickHandler"
                       v-if="vitaminLabels.length && vitaminData.length"
                       style="max-height:80vh;"
                       :name="'Subscores'"
                       :legend="true"
                       :type="'polarArea'"
                       :set-labels="['Current','Previous']"
                       :chart-labels="vitaminLabels"
                       :chart-data="[vitaminData]">
        </generic-chart>
      </div>

      <div class="col-md-4">
        <div class="row pt-5">

          <!--          <div class="insights col-md-12 mb-5">-->
          <!--            <ul class="pl-0 mb-0" style="list-style-type: none">-->
          <!--              <li class="mb-3">-->
          <!--                <p class="mb-1">Insight 1</p>-->
          <!--                <span class="small">-->
          <!--                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.-->
          <!--                  Autem blanditiis pariatur quis repudiandae, veritatis voluptatum.-->
          <!--                </span>-->
          <!--              </li>-->
          <!--              <li class="mb-3">-->
          <!--                <p class="mb-1">Insight 2</p>-->
          <!--                <span class="small">-->
          <!--                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.-->
          <!--                  Adipisci atque cum cumque, id nostrum sint!-->
          <!--                </span>-->
          <!--              </li>-->
          <!--              <li class="mb-3">-->
          <!--                <p class="mb-1">Insight 3</p>-->
          <!--                <span class="small">-->
          <!--                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.-->
          <!--                  Beatae itaque modi placeat sint temporibus vel?-->
          <!--                </span>-->
          <!--              </li>-->
          <!--            </ul>-->
          <!--          </div>-->
          <div class="col-md-4 mb-5">
            <div class="label-centered">{{ $t('message.vip') }}</div>
            <div class="score score-medium score-medium-three"
                 :class="submission ? ('score-c-'+truncate(submission.vipscore,0)+' score-bc-'+truncate(submission.vipscore,0)) : null">
              <div :class="submission ? (submission.vipscore % 1 > 0 ? 'small-score' : '') : ''"
                   class="content">
                {{ submission ? truncate(submission.vipscore, 1) : '--' }}
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-5">
            <template v-for="(team,i) in user.teams" v-if="shownTeam===i">
              <!--              <div class="text-center label-centered d-flex justify-content-between align-content-center">-->
              <div class="text-center label-centered">
                <!--                <button v-if="user.teams.length > 1"-->
                <!--                        style="line-height:1"-->
                <!--                        @click.prevent="(i > 0) ? shownTeam&#45;&#45; : shownTeam = user.teams.length -1"-->
                <!--                        class="h-auto text-muted p-0 btn btn-link btn-sm">-->
                <!--                  <i class="fas fa-caret-left"></i>-->
                <!--                </button>-->
                {{ truncate(team.Title, 8, 'string') }}
                <!--                <button v-if="user.teams.length > 1"-->
                <!--                        style="line-height:1"-->
                <!--                        @click.prevent="(i < (user.teams.length -1) ? shownTeam++ : shownTeam = 0)"-->
                <!--                        class="h-auto text-muted p-0 btn btn-link btn-sm">-->
                <!--                  <i class="fas fa-caret-right"></i>-->
                <!--                </button>-->


              </div>
              <!--              <div class="label-centered">{{ $t('message.team_score') }}</div>-->
              <div class="score score-medium score-medium-three"
                   :class="team ? ('score-c-'+truncate(team.vipscore,0)+' score-bc-'+truncate(team.vipscore,0)) : null">
                <div :class="team ? (team.vipscore % 1 > 0 ? 'small-score' : '') : ''"
                     class="content">
                  {{ submission ? truncate(team.vipscore, 1) : '--' }}
                </div>
              </div>
            </template>
            <div v-if="user.teams.length > 1" class="team-slider-pager text-center mt-1">
              <template v-for="(team,i) in user.teams">
                <button :class="shownTeam === i ? 'score-c-4' : 'text-muted'"
                        @click="shownTeam = i"
                        style="font-size:10px"
                        class="btn-link btn small btn-sm indicator pl-1 pr-1">
                  <i class="fa-xs fas fa-circle"></i>
                </button>
              </template>
            </div>
          </div>
          <div class="col-md-4 mb-5">
            <div class="label-centered">{{ company.Title }}</div>
            <!--            <div class="label-centered">{{ $t('message.company_score') }}</div>-->
            <div class="score score-medium score-medium-three"
                 :class="company ? ('score-c-'+truncate(company.vipscore,0)+' score-bc-'+truncate(company.vipscore,0)) : null">
              <div :class="company ? (company.vipscore % 1 > 0 ? 'small-score' : '') : ''"
                   class="content">{{ company ? truncate(company.vipscore, 1) : '--' }}
              </div>
            </div>
          </div>
          <div class="vitamin-information col-md-12 mb-5">
            {{ activeInfo }}
          </div>
        </div>
      </div>
      <div class=" col-md-12">
        <all-vitamins :type="'user'"
                      ref="allvitamins"
                      class="p-0 mb-5"
                      @clickVitamin="vitaminClickedHandler"
                      :vitamins="vitamins"
                      :submission="submission"
                      :scores="submission.data.children"></all-vitamins>
        <div class="mb-4 border-bottom-grey">

        </div>
      </div>
      <div class="col-md-12 text-right" v-if="!submission.reviewed && userRole !== 'manager'">
        <button @click.prevent="submitReview($event)" class="btn btn-primary">
          {{ $t('message.submit_review') }}
        </button>
      </div>
    </div>
    <div class="evolution-team-scores" v-show="activeChart === 'evolution'">
      <div class="row-flex flex-v align-items-baseline">
        <h2 class="w-auto mr-5">{{ $t('message.evolution') }}</h2>
        <label :for="submission.id+'-evolution-start'"
               class="mr-2">
          {{ $t('message.from') }}
        </label>
        <input
          v-model="evolutionStart"
          :name="submission.id+'-evolution-start'"
          :id="submission.id+'-evolution-start'"
          :max="today"
          min="2020-01-01"
          type="date"
          class="w-auto styled-input c_date_picker form-control">
        <label :for="submission.id+'-evolution-end'"
               class="ml-2 mr-2">
          {{ $t('message.to') }}
        </label>
        <input
          v-model="evolutionEnd"
          :name="submission.id+'-evolution-end'"
          :id="submission.id+'-evolution-end'"
          :max="today"
          min="2020-01-01"
          type="date"
          class="w-auto styled-input c_date_picker form-control">
      </div>
      <evolution-chart :name="submission.Title+'-evolution'"
                       v-if="vitaminLabels.length && vipHistory.length"
                       :dateLabels="evolutionDatesFormatted"
                       :setLabels="evolutionLabels"
                       :entity="user"
                       :type="'user'"
                       :start="evolutionStart"
                       :end="evolutionEnd"
                       :vitaminScores="vitaminScores"
                       :chartData="[vipHistory]">
      </evolution-chart>
      <pre class="text-white">

<!--        prev: {{previousSubmission}}-->
      </pre>

    </div>


  </div>
</template>
<script>
import AllVitamins from './AllVitamins'
import GenericChart from '../Charts/GenericChart'
import store from "../../store/store";
import EvolutionChart from "../Charts/EvolutionChart"
import moment from 'moment'

export default {
  components: {
    AllVitamins,
    GenericChart,
    EvolutionChart
  },
  data() {
    return {
      activeVitaminIndex: 0,
      shownTeam: 0,
      // evolutionStart: moment(this.submission.finalized).subtract(14, 'days').format('YYYY-MM-DD'),
      evolutionStart: moment(this.submission.finalized).format('YYYY-MM-DD'),
      evolutionEnd: moment().format('YYYY-MM-DD'),
      activeChart: 'current',
      company: store.getters.getCompany,
      vitamins: [],
      teamHistories: [],
      evolutionData: [],
      vitaminScores: {},
      vipHistory: [],
      previousSubmission: null
    }
  },
  methods: {
    saveAllComments() {
      store.dispatch('saveAllComments', {userid: this.submission.user, submissionid: this.submission.id})
    },
    submitReview(e) {
      let btn = e.target;
      btn.classList.add('loading');
      this.axios.put('/submissions/' + this.submission.id, {
        status: 'reviewed',
        reviewed: new Date()
      }).then(r => {
        this.submission.status = 'reviewed';
        this.submission.reviewed = new Date();
        btn.classList.remove('loading');
        this.$emit('close')
      })
    },
    vitaminClickedHandler(index){
    //  console.log('clicked vitamin handler',index)
      this.activeVitaminIndex = index
    },
    vitaminChartClickHandler(evt) {
      const index = evt[0]._index;
      // this.activeVitamin = this.vitamins[index]
      this.vitaminClickedHandler(index)
      // this.activeVitaminIndex = index
      this.$refs.allvitamins.setActiveVitamin(index)
    },
    getVitaminsArray(scoredata, correctDay = true) {
      let vitaminArray = [];
      scoredata.forEach((vitamin, vitaminIndex) => {
        let point = null;
        if (correctDay) {
          point = scoredata[vitaminIndex].average
        }
        vitaminArray.push(point)
      });

      return vitaminArray;
    },
    async getSubmissions() {
      let submissionsFiltered = {};
      this.vipHistory = [];
      const submissions = await this.axios.get(`/submissions?status_ne=draft&_sort=finalized:ASC&finalized_gte=${this.evolutionStart}&finalized_lte=${moment(this.evolutionEnd).add(1, 'day').format('YYYY-MM-DD')}`);

      submissions.data.forEach(submission => {
        let submissionDate = moment(submission.finalized);
        this.dates.forEach(date => {
          let day = moment(date);
          let val = null;

          if (day.isSame(submissionDate, 'day')) {
            val = submission.vipscore
          }
          this.vipHistory.push(val)
        })
      });
    },
    async getPreviousSubmission() {
      // console.log('getting previous submission');
      const previous = await this.axios.get('/submissions?finalized_lt=' + this.submission.finalized + '&_limit=1&_sort=finalized:DESC');
      if (previous.data.length) {
        this.previousSubmission = previous.data[0];
        // console.log('previous', this.previousSubmission)
        this.evolutionStart = moment(this.previousSubmission.finalized).format('YYYY-MM-DD')
        // console.log('ev start', this.evolutionStart)
      }

      // console.log('previous', this.previousSubmission)
    },

    async getVitamins() {
      const vitamins = await this.axios.get('/vitamines?published=1&_sort=sort:ASC');
      this.vitamins = vitamins.data;
      this.vitaminScores = {};
      this.vitamins.forEach(vitamin => {
        this.vitaminScores[vitamin.id] = vitamin
      })
    },
  },
  created() {
    this.getVitamins();
    this.getSubmissions();
    this.getPreviousSubmission();
  },
  watch: {
    submission() {
      this.getPreviousSubmission();
    },
    evolutionStart() {
      this.getSubmissions();
    },
    evolutionEnd() {
      this.getSubmissions();
    },
    evolutionData() {
      // console.log('evolution data changed', this.evolutionData)
      this.formatEvolutionData(this.evolutionData)
    }
  },
  computed: {
    activeInfo() {
      let key = '';
      let ret = null
      let lang = store.getters.getLang;
      if (lang !== 'nl') {
        key = '_' + lang;
      }
      if(this.vitamins[this.activeVitaminIndex]){
        ret = this.vitamins[this.activeVitaminIndex]['Information' + key]
      }
      return ret
    },
    dates() {
      return this.getDatesBetween(this.evolutionStart, this.evolutionEnd, 'YYYY-MM-DD')
    },
    labels() {
      return this.getDatesBetween(this.evolutionStart, this.evolutionEnd)
    },
    computedEnd() {
      return moment(this.evolutionEnd).add(1, 'day').format('YYYY-MM-DD')
    },
    evolutionLabels() {
      let labels = [this.$t('message.score')];
      return labels.concat(this.vitaminLabels)
    },
    evolutionDatesFormatted() {
      return this.getDatesBetween(this.evolutionStart, this.evolutionEnd, 'DD/MM/YYYY');
    },
    evolutionDates() {
      return this.getDatesBetween(this.evolutionStart, this.evolutionEnd, 'YYYY-MM-DD');
    },
    vitaminData() {
      let data = [];
      let vitaminScores = this.submission.data.children;
      if (vitaminScores) {
        vitaminScores.forEach(vitamin => {
          if (this.vitaminScores[vitamin.id]) {
            data.push(this.truncate(vitamin.average, 2))
          }

        });
      }

      return data
    },
    vitaminLabels() {
      const labels = [];
      if (this.vitamins) {
        this.vitamins.forEach(vitamin => {
          labels.push(this.localizedField(vitamin,'Title'))
        });
      }
      return labels
    },
  },
  props: {
    // review: {
    //   type: Boolean,
    //   default() {
    //     return true
    //   }
    // },
    user: {
      type: Object,
      default() {
        return null
      }
    },
    submission: {
      type: Object
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Review/UserReview.vue